export const CONVERT_TO_PDF ='convert-to-pdf';
export const CONVERT_PDF_TO_WORD ='convert-pdf-to-word';
export const CONVERT_PDF_TO_EXCEL ='convert-pdf-to-excel';
export const CONVERT_PDF_TO_PPT ='convert-pdf-to-ppt';
export const CONVERT_PDF_TO_IMG ='convert-pdf-to-img';
export const EXPORT_ALL_IMG ='export-all-img';
export const OCR_PDF_TO_PDF = 'ocr-pdf-to-pdf'
export const CONVERT_MAP = {
    toPdf: {
      name: CONVERT_TO_PDF,
      title: 'phantom_online:toolbar.fwConvert.toPdf',
      icon:'fv__icon-toolbar-to-pdf'
    },
    pdfToWord: {
      name: CONVERT_PDF_TO_WORD,
      title: 'phantom_online:toolbar.fwConvert.pdfToWord',
      icon:'fv__icon-toolbar-pdf-to-word'
    },
    pdfToExcel: {
      name: CONVERT_PDF_TO_EXCEL,
      title: 'phantom_online:toolbar.fwConvert.pdfToExcel',
      icon:'fv__icon-toolbar-pdf-to-excel'
    },
    pdfToPpt: {
      name:CONVERT_PDF_TO_PPT,
      title: 'phantom_online:toolbar.fwConvert.pdfToPpt',
      icon:'fv__icon-toolbar-pdf-to-ppt'
    },
    pdfToImg: {
      name:CONVERT_PDF_TO_IMG,
      title: 'phantom_online:toolbar.fwConvert.pdfToImg',
      icon:'fv__icon-toolbar-pdf-to-img'
    },
    exportAllImg: {
      name:EXPORT_ALL_IMG,
      title: 'phantom_online:toolbar.fwConvert.exportAllImg',
      icon:'fv__icon-toolbar-export-to-img'
    },
    ocrPdfToPdf: { // OCRPDF2PDF
      name: OCR_PDF_TO_PDF,
      title: 'phantom_online:toolbar.fwConvert.ocrPdfToPdf',
      icon:'fv__icon-toolbar-ocr-quick-recognition'
    },
}
